import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-email-model-view',
  templateUrl: './email-model-view.component.html',
  styleUrls: ['./email-model-view.component.scss']
})
export class EmailModelViewComponent implements OnInit {

  inbox: any = []
  @ViewChild('email_body', { static: true }) email_body;
  readonly;
  constructor(
    private dialog_ref: MatDialogRef<EmailModelViewComponent>,
    @Inject(MAT_DIALOG_DATA) public email
  ) { }

  ngOnInit() {
    if (this.email && this.email.email) {
      this.inbox = this.email.email;
    }
    if (this.email) {
      this.readonly = this.email.readonly
    }
  }
  ngAfterViewInit() {
    if (this.readonly) {

      try {
        removeClickFunction(this.email_body.nativeElement)
      }
      catch (err) {

      }
    }
  }
  close() {
    this.dialog_ref.close()
  }

}

export function removeClickFunction(elementRef) {
  try {
    if (elementRef && elementRef.getAttributeNames) {
      if (elementRef.getAttributeNames().includes('href')) {
        elementRef.removeAttribute('href')
      }
      if (elementRef.getAttributeNames().includes('onclick')) {
        elementRef.removeAttribute('onclick')
      }
      if (elementRef.getAttributeNames().includes('target')) {
        elementRef.removeAttribute('target')
      }
    }
    if (elementRef && elementRef.children && elementRef.children.length) {
      for (let i = 0; i < elementRef.children.length; i++) {
        removeClickFunction(elementRef.children[i])
      }
    }
  }
  catch (err) {

  }
}
